import { gql } from 'apollo-boost';

export const newCustomPortalMutation = gql`
  mutation newCustomPortalMutation($template: JSONString!, $name: String) {
    newCustomPortal(template: $template, name: $name) {
      success
      id
    }
  }
`;
